import React, {useState} from 'react'
import {Container, Header, Segment} from 'semantic-ui-react'
import {Link} from "react-router-dom";

function About() {

  const [current, setCurrent] = useState(0)

  const displayStyle = (num) => {
    return num === current ? {"display": "block"} : {"display": "none"}
  }

  const updateCurrent = (num) => {
    setCurrent(num);
  }

  return (
    <Container text>
      <Header as='h3' textAlign='center'>Полезная Информация</Header>
      <Header as='h5' style={displayStyle(0)}><Link onClick={() => updateCurrent(1)}>Въезд в Польшу из Беларуси</Link></Header>
      <Header as='h5' style={displayStyle(0)}><Link onClick={() => updateCurrent(2)}>Въезд в Литву из Беларуси</Link></Header>
      <Header as='h5' style={displayStyle(0)}><Link onClick={() => updateCurrent(3)}>Въезд в Латвию из Беларуси</Link></Header>
      <Header as='h5' style={displayStyle(0)}><Link onClick={() => updateCurrent(4)}>Правила пересечения границы с детьми.</Link></Header>
      <Header as='h5' style={displayStyle(0)}><Link onClick={() => updateCurrent(5)}>Денежные средства.</Link></Header>
      <Container style={displayStyle(1)}>
        Въезд в Польшу на автомобиле с беларусской регистрацией без его владельца невозможен.
        Владелец автомобиля должен присутствовать в машине в момент пересечения границы.
        Ему не обязательно находиться за рулем. Проезд по доверенности невозможен.
        Запрет распространяется на юр лиц.<br/><br/>
        Запрещено ввозить: <br/>
        1) мясо, консервы, молочку, табак, морепродукты, овощи, фрукты <br/>
        2) Товары гигиены <br/>
        3) Бытовую технику <br/>
        4) Самогон <br/>
        Вскрытые упаковки в разумных количествах для нужд в пути и личная техника - смартфоны, ноутбуки - можно <br/>
        Разрешено до 2 кг мед, хлебобулочные изделия, крупы.
        Разрешен алкоголь - 2 литра игристого вина, 4 литра вина, 16 литров пива.<br/>
        <br/><Link onClick={() => updateCurrent(0)}>Назад</Link>
      </Container>
      <Container style={displayStyle(2)}>
        Въезд в Литву на автомобиле с беларускими номерами возможен ТОЛЬКО с литовским ВНЖ или литовской визой <br/>
        Въезд в Литву на автомобиле с польскими номерами возможен с польской визой и КЧП/КСП <br/><br/>
        Ввоз в Литву практически всех продуктов, алкоголя, напитков, табака запрещен. <br/>
        Только напитки, продукты дла легкого перекуса в пути. <br/>
        <br/><Link onClick={() => updateCurrent(0)}>Назад</Link>
      </Container>
      <Container style={displayStyle(3)}>
        Въезд в Латвия на автомобиле с беларускими номерами вообще говоря запрещен. (Есть редкие исключения - узнавайте у компетентных органов) <br/><br/>
        В Латвию из Беларуси можно ввозить ограниченное количество продуктов питания, в основном сухие и не скоропортящиеся. Большинство продуктов запрещено.
        Правила часто меняются, рекомендуем уточнять на официальном сайте https://www.pvd.gov.lv/  <br/>
        <br/><Link onClick={() => updateCurrent(0)}>Назад</Link>
      </Container>
      <Container style={displayStyle(4)}>
        Если вы едете с детьми в возрасте до 3 лет или детьми-инвалидами в возрасте до 18 лет – вы имеете право на внеочередной въезд в пункты пропуска при выезде из Беларуси. <br/>
        С ребенком-инвалидом сразу едем к границе, заезжать в зону ожидания НЕ НУЖНО.  <br/>
        Оператору показываем паспорт ребенка, техпаспорт на авто. <br/>
        <br/><Link onClick={() => updateCurrent(0)}>Назад</Link>
      </Container>
      <Container style={displayStyle(5)}>
        Вывоз и ввоз денежных средств из Беларуси:  <br/>
        До 10.000$ без декларирования <br/>
        От 10.000$ до 100.000$ обязательно декларировать <br/>
        От 100.000$ обязательно декларировать и документы о происхождении средств <br/><br/>
        Ввоз денежных средств в ЕС:  <br/>
        До 10.000 евро без декларирования <br/>
        От 10.000 евро до 100.000 евро обязательно декларировать <br/>
        От 100.000 евро обязательно декларировать и документы о происхождении средств. <br/>
        В Литве и Латвии могут попросить документы о происхождении средств при любой сумме. <br/><br/>
        Вывоз денежных средств в ЕС:  <br/>
        Польша не контролирует вывоз денежных средств <br/>
        Литва и Латвия разрешает вывозить до 60 евро, можно вывозить доллары. Дальше на доллары действуют лимиты ввоза в Беларусь <br/>
        <br/><Link onClick={() => updateCurrent(0)}>Назад</Link>
      </Container>
    </Container>
  )
}

export default About
